var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#71778a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -1176)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 30,
    transform: "translate(23 1176)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.305 1181.072)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 11,
    rx: 1,
    transform: "translate(1.695 10.928)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 18,
    rx: 1,
    transform: "translate(9.695 3.928)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6,
    height: 23,
    rx: 1,
    transform: "translate(17.695 -1.072)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphGrey);
export default __webpack_public_path__ + "static/media/graph_grey.4eae9f2aa13dabb05bc220f181cd5189.svg";
export { ForwardRef as ReactComponent };